import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useChat } from "@/components/layouts/Chat/ChatContext";
import { dreamUser } from "@/entities/messaging/types";
import { getCurrentTimeUTC, isoToTimeString } from "@/utils/datetime";
import { buildScheduleSummary } from "@/components/global/Chat/components/ScheduleModal/buildScheduleSummary";
import { ScheduleData } from "@/components/global/Chat/components/ScheduleModal/types";

const TRANSLATION_KEY = "chat.scheduleModal";

type ScheduleConfirmation =
  | { kind: "created"; payload: ScheduleData }
  | { kind: "updated"; payload: ScheduleData }
  | { kind: "canceled"; name: string };

export const useScheduleConfirmation = () => {
  const { t } = useTranslation();
  const { addMessages } = useChat();

  return useCallback(
    (confirmation: ScheduleConfirmation) => {
      const { kind } = confirmation;
      let message: string;
      let inlineAction: "manage-scheduled-reports" | undefined;

      if (kind === "canceled") {
        message = t(`${TRANSLATION_KEY}.confirmationMessageCancel`, {
          name: confirmation.name
        });
      } else {
        const isUpdate = kind === "updated";
        const key = isUpdate
          ? "confirmationMessageUpdate"
          : "confirmationMessage";
        message = t(`${TRANSLATION_KEY}.${key}`, {
          description: buildScheduleSummary(
            t,
            confirmation.payload,
            "delivery"
          ),
          time: isoToTimeString(confirmation.payload.deliveryTime)
        });
        if (!isUpdate) inlineAction = "manage-scheduled-reports";
      }

      addMessages([
        {
          id: `schedule-${kind}-${Date.now()}`,
          user: dreamUser,
          message,
          timestamp: getCurrentTimeUTC().toString(),
          inlineAction
        }
      ]);
    },
    [t, addMessages]
  );
};
